module.exports = __webpack_public_path__ + "img/image4.909e3252.png";